import React from 'react';
import { Typography, Paper, useTheme } from '@mui/material';
import { config_strings } from '../config/config';

const IntroSection = () => {
    const theme = useTheme();
    
    return (
      <Paper elevation={3} sx={{ 
        mb: 2, 
        p: 2, 
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        width: '100%',
        maxWidth: { xs: '300px', sm: '100%' },
        mx: 'auto'
      }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
          { config_strings.intros.provenance.title }
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
          { config_strings.intros.provenance.text }
        </Typography>
      </Paper>
    );
};

export default IntroSection;